export class MenuModel {
    'IdCategoria':number;
    'IdCategoriaPadre':number;
    'Hijos':Array<MenuModel>;
    'Categoria':string;
    'url':string;
}   